<template>
  <div class="expert flex flex-column flex-middle">
    <img v-if="data.expertImage" :src="data.expertImage" class="expert-img" />
    <img v-else :src="$oss('common/empty-img-expert.png')" class="expert-img" />
    <div class="expert-name">
      {{ data.userRealName }}
    </div>
    <div class="expert-sub-info flex flex-row flex-between">
      <div class="ellipsis">
        {{ data.expertUniversity || data.expertWorkUnit }}
      </div>
      <div>{{ data.expertPositionTitle || eduMap[+data.expertEducation] }}</div>
    </div>
    <!-- <div class="flex-1 flex flex-column flex-between">
      <div></div>
      <div class="flex flex-row flex-between">
        <div class="expert-edu">{{ eduMap[+data.expertEducation] }}</div>

      </div>
    </div> -->
    <div class="expert-text">
      {{ data.expertBrief || "专家简介专家简介需要提供" }}
    </div>
    <div class="expert-btn pointer" @click="toDetail(data)">查看详情</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    eduMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail(data) {
      this.$router.push({
        name: "expertsDetail",
        query: {
          id: data.expertId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
@import "@/style/common";
.expert {
  color: #333;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  transition: all ease-in-out 0.3s;
  &:hover {
    box-shadow: 0 0 10px 1px rgba(#145dc5, 0.4);
  }
  &-img {
    width: 120px;
    height: 120px;
    border-radius: 60px;
    object-fit: cover;
  }
  &-name {
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
  }
  &-sub-info {
    margin-bottom: 15px;
    div:first-child {
      max-width: 100px;
      margin-right: 20px;
    }
    div:last-child {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -10px;
        top: 5px;
        width: 1px;
        height: 10px;
        background: #999;
      }
    }
  }
  &-text {
    margin-bottom: 20px;
    font-size: 14px;
    color: #999;
    line-height: 22px;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &-edu {
    color: #999999;
    padding: 10px 0;
  }
  &-btn {
    background: #fff;
    color: $theme-color;
    border: 1px solid $theme-color;
    padding: 5px 15px;
    border-radius: 4px;
    &:hover {
      color: #fff;
      background: $theme-color;
    }
  }
}
</style>
